<div class="multi-choice-group">
  @for (option of visibleOptions$(); track option.id) {
    @if (question().useOtherInd && question().useOtherPosition === $index) {
      <ng-container *ngTemplateOutlet="other"></ng-container>
      <ng-container *ngTemplateOutlet="otherText"></ng-container>
    }

    @if (!!option.stimulus?.mediaId) {
      <empathy-option-media [media]="option.stimulus" [altText]="option.text | content: question().id" (clicked)="onMediaChecked(option)">
        <ng-container [ngTemplateOutlet]="checkbox"></ng-container>
      </empathy-option-media>
    } @else {
      <div class="multi-choice-group__checkbox" [class.use-media]="useMedia$()" (click)="onMediaChecked(option)">
        <ng-container [ngTemplateOutlet]="checkbox"></ng-container>
      </div>
    }

    <ng-template #checkbox>
      <mat-checkbox
        color="accent"
        [checked]="questionGrp().get('value').value | checked: option.value"
        [disabled]="
          !(questionGrp().get('value').value | checked: option.value) &&
          question().maxLength > 0 &&
          questionGrp().get('value').value?.length === question().maxLength
        "
        (click)="$event.stopPropagation()"
        (change)="onChecked($event, option)"
      >
        <div
          class="survey-viewer__html-content fs__md"
          [innerHTML]="option.text | content: question().id"
          surveyAutoFocus
          [condition]="questionGrp().get('value').value | checked: option.value"
        ></div>
      </mat-checkbox>
    </ng-template>

    @if (question().useOtherInd && question().useOtherPosition >= visibleOptions$().length && $last) {
      <ng-container *ngTemplateOutlet="other"></ng-container>
      <ng-container *ngTemplateOutlet="otherText"></ng-container>
    }
  }
  <ng-template #other>
    <div class="multi-choice-group__checkbox" [class.use-media]="useMedia$()" (click)="onMediaChecked({ value: otherOption.value })">
      <mat-checkbox
        color="accent"
        [checked]="questionGrp().get('value').value | checked: otherOption.value"
        [disabled]="question().maxLength > 0 && questionGrp().get('value').value?.length === question().maxLength"
        (click)="$event.stopPropagation()"
        (change)="onChecked($event, otherOption)"
      >
        <span class="survey-viewer__html-content fs__md">{{ otherOption.text }}</span>
      </mat-checkbox>
    </div>
  </ng-template>
</div>

<ng-template #otherText>
  @if (questionGrp().get('value').value | checked: otherOption.value) {
    <div class="question-form__input">
      <span class="label survey-viewer__html-content fs__md fw__400" [innerHTML]="question().otherLabel | content: question().id"></span>
      <mat-form-field appearance="outline" class="eiq-survey-textarea">
        <textarea
          matInput
          surveyAutoFocus
          [formControl]="questionGrp().get('otherText') | toFormControl"
          [required]="questionGrp().get('value').value === 'OTHER'"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
  }
</ng-template>
